export default __webpack_public_path__ + "static/media/team108.9f73339e.JPG";